export default __webpack_public_path__ + "static/media/rrhh.aec00c65.png";